import { Resource } from '../i18n';

export const es: Resource = {
  accessibility: {
    advantages: 'Ir a {{advantage}}',
    article: {
      title: 'Ir a {{articleTitle}}',
    },
    button: {
      change_password: 'Confirmar cambio de contraseña',
      close: 'Cerrar',
      delete: 'Quitar filtro {{filterName}}',
      filterMinus: 'Cerrar filtros',
      filterPlus: 'Ampliar filtros',
      menu: 'Abrir el menú',
      more_info: 'Más información',
      orderTableMinus: 'Cerrar',
      ordersTablePlus: 'Seguir leyendo',
      quickPurchaseLastOrder: 'Recompra rápidamente todos los productos de tu último pedido',
      smallArrow: 'Ir',
      swiper_next: 'Swiper siguiente',
      swiper_prev: 'Anterior swiper',
    },
    checkout: {
      coupon: 'Añadir cupón a la cesta',
    },
    consents: {
      newsletter: 'Acepto el boletín de noticias',
    },
    filter: {
      legend: 'Elegir filtro macrocategoría',
    },
    footer: {
      socialIcon: 'Visite nuestro canal social de {{socialName}}',
    },
    form: {
      addToCartForm: {
        buttons: {
          availabilityEmailNotification: {
            addLong: {
              label: 'Avísame cuando esté disponible {{productName}}',
            },
          },
          decreasingQnt: 'Disminución de la cantidad',
          increasingQnt: 'Aumentar la cantidad',
          submit: {
            label: 'Añadir a la cesta',
          },
          submitButNotAvailable: {
            label: '{{productName}} no disponible',
          },
        },
      },
      giftCard: {
        title: 'Tarjeta regalo',
      },
    },
    icons: {
      account: 'Vaya a su área personal',
      account_login: 'Ir a inicio de sesión o registro',
      cart: 'Ir a la cesta',
      cart_not_empty: 'Tienes {{items}} en el carrito, ir',
      geolocation: 'Localiza mi ubicación',
      giftCard: 'Regala una tarjeta regalo',
      hidden: 'Revela la contraseña',
      iconSpeechRecognition: 'Iniciar búsqueda por voz',
      languages: 'Seleccionar idioma',
      menu: 'Menú principal',
      minus: 'Eliminar',
      plus: 'Añadir',
      search: 'Búsqueda en el sitio web',
      violetta: 'Abrir la asistencia IA',
      wishlist: 'Ir a su lista de deseos',
      wishlist_not_empty: 'Tienes {{items}} en la lista de deseos, ir',
      zoomIn: 'Ampliar',
      zoomOut: 'Alejar la imagen',
    },
    landing: {
      selection: 'Ir a la selección',
    },
    logo: {
      goToHome: 'Página de inicio',
    },
    mandatory: '*Campos obligatorios',
    menu: {
      main: 'Principal',
      secondary: 'Secundaria',
    },
    product: 'Ir a la página del producto {{productName}}',
    productTile: {
      bannerPromo: 'Ir a la página de promoción',
      design: 'Tarjetas regalo gráficas',
      gift_card: 'Seleccionar tarjeta regalo',
      productName: 'Ir a {{productName}}',
      wishlistAdd: 'Añadir {{productName}} a su lista de deseos',
      wishlistRemove: 'Eliminar {{productName}} de su lista de deseos',
      wishlistToggle: 'Añadir o eliminar {{productName}} de su lista de deseos',
    },
    product_stickyBar: 'Barra fija del producto',
    progressbar: 'Status: {{currentValue}}',
    quantity: 'Cantidad',
    quantityMinus: 'Disminución de la cantidad a {{quantity}}',
    quantityPlus: 'Aumento de la cantidad a {{quantity}}',
    radioInput: 'Selecciona {{value}}',
    ratings: {
      percentage: 'Porcentaje de votos',
      progress: 'Representa una barra con el porcentaje de votos',
      score: 'Representa la puntuación de 1 a 5',
      star: 'Clasificación por estrellas',
    },
    select: {
      quantity: 'Seleccione la cantidad para {{productName}}',
      review_filter: 'Filtrar por número de estrellas',
    },
    skip: {
      banner: 'Ir al menú',
      footer: 'Saltar al pie de página',
      main: 'Ir al contenido principal',
    },
    storeLocator_arrow: 'Añadir a Google Maps',
  },
  account: {
    accessDenied: 'No puedes acceder a esta zona reservada.',
    coupons: {
      active: 'Activo',
      code: 'Código',
      copied: 'Copiado',
      copy: 'Copia',
      copyCode: 'Copiar código {{code}}',
      description: 'Descripción',
      empty: 'Ningún vale de descuento',
      expired: 'Caducado',
      expiryDate: 'Fecha de caducidad',
      numberOfUses: 'Número de usos',
      status: 'Estado',
    },
    create: 'Crea tu cuenta',
    creditCards: {
      addCreditcard: 'Añade tarjeta de crédito o débito',
      noCardRegistered: 'No hay ninguna tarjeta de crédito registrada',
    },
    edit: 'Modificar',
    emptyWishlist: 'No se añadió ningún producto a la lista de deseos',
    info: {
      additionalInformation: {
        children: {
          birthdate: 'Fecha de nacimiento',
          name: 'Nombre',
          sex: 'Sexo',
          surname: 'Apellidos',
          title: 'Niño',
        },
        document: {
          authorityDescription: 'Descripción autoridad',
          authorityType: 'Tipo autoridad',
          districtName: 'Nombre distrito',
          districtType: 'Tipo distrito',
          documentNumber: 'Número de documento',
          documentType: 'Tipo de documento',
          releaseDate: 'Fecha de emisión',
          title: 'Documento',
        },
        other: 'Otro',
        title: 'Datos adicionales',
      },
      birthdate: 'Fecha de nacimiento',
      businessType: {
        label: 'Tipo de actividad',
        options: {
          COMPANY: 'Empresa',
          PROPRIETORSHIP: 'Empresa individual/profesional',
        },
      },
      company: 'Razón social',
      editPassword: 'Cambiar contraseña',
      email: 'Correo electrónico',
      loginData: 'Datos de inicio de sesión',
      name: 'Nombre',
      pec: 'Dirección correo electrónico certificado',
      personalAddresses: 'Direcciones',
      personalData: 'Datos personales',
      phone: 'Móvil',
      profile: {
        label: 'Perfil',
        options: {
          BUSINESS: 'Trabajo',
          PRIVATE: 'Privado',
        },
      },
      secondaryPhone: 'Otro teléfono',
      sex: {
        options: {
          F: 'Mujer',
          M: 'Hombre',
          O: 'No especificado',
        },
        title: 'Sexo',
      },
      surname: 'Apellidos',
      taxCode: 'Código fiscal',
      title: 'Datos de facturación',
      uniqueCode: 'Código SDI',
      vatNumber: 'Número de IVA',
    },
    insertCredentials: 'Si estás registrado, introduce tu correo electrónico y contraseña',
    login: 'Entrar',
    logout: 'Salir',
    loyalty: {
      infoPointNextLevel: '¡Te faltan {{points}} puntos para desbloquear el siguiente nivel!',
      pointsBalance: 'tu saldo de puntos',
      pointsTable: {
        awardsLabel: 'Pulsar',
        couponLabel: 'Código de descuento',
        footerText: 'Utiliza el código de descuento en la fase de compra',
        pointsLabel: 'Puntos',
        ptLabel: 'pt',
      },
      shopping: 'empieza a comprar',
    },
    newCustomer: '¿Eres un cliente nuevo?',
    orders: {
      details: {
        closeOrderDetails: 'Cerrar',
        code: 'Código',
        color: 'Color:',
        date: 'Fecha',
        invoiceDownload: 'Descargar factura',
        invoiceNotReady: 'La factura aún no está preparada',
        paymentAddress: 'Pago',
        price: 'Precio',
        product: 'Producto',
        quantity: 'Cantidad:',
        receiverShipping: 'Destinatario',
        review: 'Resumen',
        rightOfWithdrawal: 'Quiero ejercer mi derecho de desistimiento',
        rightOfWithdrawalHasExpired: 'El plazo para ejercer el derecho de desistimiento ha vencido',
        shippingAddress: 'Envío',
        showOrderDetails: 'Ver detalle del pedido',
        size: 'Talla:',
        status: 'Estado',
        tax: 'IVA',
        total: 'Total',
        totalAmount: 'total por pagar: ',
        totalProducts: 'total de productos',
        totalProductsTaxable: 'Coste de productos (IVA excluido)',
        totalShipping: 'envío:',
        trackingCode: 'Seguimiento del pedido',
        unitPrice: 'Precio por unidad',
        warehouseName: 'Almacén: {{warehouse}}',
      },
      noOrders: 'Actualmente no hay pedidos',
      status: {
        arrived: 'Entregado',
        cancelled: 'Cancelado',
        preparing: 'En preparación',
        readyToShipping: 'Listo para enviarse',
        shipping: 'Enviado',
        waitPayment: 'A la espera del pago',
        waitingAcceptance: 'En aceptación',
      },
      trackOrdersState: 'Sigue el estado de tus pedidos',
    },
    passwordForgotten: '¿Olvidaste tu contraseña?',
    quickReorder: {
      noProducts: 'ningún producto comprado anteriormente',
      productCount: '',
      productCount_one: '{{count}} producto',
      productCount_other: '{{count}} productos',
      table: {
        product: 'Producto',
        quantity: 'Cantidad',
      },
    },
    register: 'Registrados',
    sectionDisabled: 'Sección deshabilitada',
    taxBenefits: {
      alerts: {
        danger: 'Los documentos no han sido aprobados',
        success: 'Usuario habilitado',
        warning: 'Los documentos están en fase de aprobación',
      },
    },
    userRegistered: '¿Eres un cliente registrado?',
    welcomeMessage: 'Hola, {{name}}: descubre tu área personal',
    wishlist: 'Incluir en la lista de deseos',
  },
  alert: {
    CART_DIFFERENT_SKU_PRICE: '',
    CART_INVOICE_MANDATORY_FLAG: 'Solicitar factura para finalizar el pedido',
    CART_MINIMUM_COST: 'No se alcanzó el importe mínimo del carrito',
    CART_MIN_CAR_SELLER_VIOLATED: '',
    CART_MIN_CAR_WAREHOUSE_VIOLATED: 'No se alcanzó el importe mínimo del carrito',
    CART_REGION_NOT_REACHABLE_EXTRA_FRESH: '',
    CART_SKU_NOT_SHIPPABLE_IN_COUNTRY_VIOLATED: 'Este producto no puede venderse en el país seleccionado',
    GUEST_CHECKOUT_NOT_ALLOWED: '',
    INVOICE_MANDATORY_MISSING_DATA: 'Se ha solicitado la factura, pero faltan los datos de facturación',
    MISSING_ADVANTAGE_PROMO_GIFT:
      'Te recordamos que tienes la posibilidad de seleccionar productos de regalo antes de finalizar la compra',
    MISSING_BILLING_ADDRESS: 'Falta la dirección de facturación',
    MISSING_EMAIL: 'Falta introducir el correo electrónico',
    MISSING_PAYMENT_METHOD: 'Falta seleccionar la forma de pago',
    MISSING_SHIPPING_ADDRESS: 'Falta la dirección de envío',
    MISSING_SHIPPING_PROFILE: 'Falta seleccionar el perfil de envío',
    UNSOLICITED_INVOICE: 'Atención, no se ha solicitado la emisión de la factura para este pedido',
    WAREHOUSEITEM_NOT_IN_STOCK: '',
    WAREHOUSESKU_NOT_AVAILABLE: 'Producto no disponible',
  },
  api: {
    error: {
      AddingSkuNotAllowed: 'No es posible comprar este producto.',
      AddingSkuNotCompatible: '',
      AddingSkuNotSellable: 'El producto que se está intentando añadir no se puede vender.',
      CouponAlreadyUsedException: 'Cupón ya utilizado',
      CouponCartRangeException: 'El cupón no es aplicable a este carrito',
      CouponInvalidException: 'El código introducido no corresponde a ningún cupón y no es aplicable a este carrito',
      CouponLoggedGuestException: 'Para usar el cupón, accede o regístrate en el sitio',
      CustomerCannotSetFeedbackException:
        'No hemos encontrado entre tus compras ningún pedido que contenga este producto',
      CustomerEmailAlreadyExistException: 'Correo electrónico ya utilizado',
      CustomerEmailNotValid: 'Correo electrónico no válido',
      CustomerEmailNotVerifiedException:
        'Para poder continuar, es necesario confirmar el registro mediante el enlace que se encuentra en el correo electrónico recibido después del registro.',

      CustomerNotFoundException:
        'La dirección introducida no consta en nuestros sistemas. Comprueba que es correcta y vuelve a intentarlo.',
      CustomerUsernameAlreadyExistException: 'Nombre de usuario ya utilizado',
      CustomerVatNumberAlreadyExistException: 'Tu cuenta está bloqueada',
      DataReferenceException: 'El código introducido no es válido',
      DepositPaymentCardNoRemainingCreditException: 'No queda crédito',
      DepositPaymentCardNotFoundException: 'Código no reconocido',
      DepositPaymentCardNotPermittedOnCartException: 'No es posible usar la tarjeta regalo para comprar otra',
      EJBException: 'Error interno',
      LoginException: 'Nombre de usuario o contraseña no válidos',
      LoginUserNotFoundException: 'Correo electrónico no encontrado',
      SystemException: 'Error interno',
      TaxCodeCheckDigitException:
        'El código fiscal introducido no es válido. Comprueba el valor introducido y vuelve a intentarlo.',
      TaxCodeLenghtException:
        'El código fiscal introducido no es válido. Comprueba el valor introducido y vuelve a intentarlo.',
      VatNumberCheckDigitException:
        'El número de IVA introducido no es válido. Comprueba el valor introducido y vuelve a intentarlo.',
      VatNumberLenghtException:
        'El número de IVA introducido no es válido. Comprueba el valor introducido y vuelve a intentarlo.',
      title: 'Error',
      usernotlogged: 'sesión expirada',
    },
  },
  assembledProduct: {
    addToAssembly: 'Añadir al montaje', // da revisionare
    addToCart: 'Añadir a la cesta', // da revisionare
    completeTheAssembly: 'Montaje completo', // da revisionare
    discountUpTo: 'Hasta {{percentage}} de descuento', // da revisionare
    discountUpToMini: 'Hasta {{percentage}}', // da revisionare
    freeShipping: 'Envío gratuito', // da revisionare
    removeFromAssembly: 'Borrar artículo', // da revisionare
    step: {
      chooseAssembledComponentPieces: 'elige {{count}} piezas de {{assembledComponentName}}',
    },
    summary: {
      actions: {
        addToCart: 'Comprar', // da revisionare
        next: 'Siguiente', // da revisionare
        previous: 'Volver', // da revisionare
      },
      badges: {
        freeShipping: 'Envío gratuito', // da revisionare
        freeShippingSavingPrice: 'Se ahorra {{value}} en gastos de envío', // da revisionare
        totalDiscount: 'Estás ahorrando {{value}}', // da revisionare
        totalProductsSavingPrice: 'Se ahorra {{value}} en productos', // da revisionare
      },
      infoMessage: {
        addAtLeast: '',
        addAtLeast_one: 'Añadir al menos un producto', // da revisionare
        addAtLeast_other: 'Añadir al menos {{count}} productos', // da revisionare
        addMoreProducts: '',
        addMoreProducts_one: 'Añadir otro producto para continuar', // da revisionare
        addMoreProducts_other: 'Añadir más productos {{count}} para continuar', // da revisionare
        completeAllStepToContinue: 'Para continuar debe completar todos los pasos', // da revisionare
        completeStepToContinue: 'Para continuar debe completar el paso', // da revisionare
      },
      status: '{{productAdded}}/{{maxProduct}} productos añadidos', // da revisionare
      subtitle: 'Resumen de su asamblea', // da revisionare
      title: 'Su total', // da revisionare
      total: 'Total', // da revisionare
      yourAssembly: 'Su montaje', // da revisionare
    },
    totalPieces: '{{total}} piezas', // da revisionare
  },
  bankAccountDetails: {
    bankName: 'Banco',
    bicSwiftCode: 'BIC/SWIFT',
    ibanCode: 'IBAN',
    ownerName: 'Beneficiario',
  },
  cart: {
    badges: {
      discountValue: 'Te ahorras {{value}}', // da revisionare
      freeShipping: 'Envío gratuito', // da revisionare
    },
    cartCampaign: {
      selectFreeSample: '',
      selectFreeSample_one: 'Seleccionar {{count}} muestra gratis',
      selectFreeSample_other: 'Seleccionar {{count}} muestras gratis',
      selectedFreeSample: '',
      selectedFreeSample_one: 'Has añadido {{count}} de {{total}} muestra gratis',
      selectedFreeSample_other: 'Has añadido {{count}} de {{total}} muestras gratis',
      toFreeSample: '<strong>{{toFreeSampleAmount}}</strong> faltan para muestra gratis',
    },
    empty: {
      description: 'Empieza a buscar algo',
      title: 'Tu carrito está vacío',
    },
    loyaltyPointsEarned: 'Tu carrito puede hacerte ganar <strong>{{loyaltyPointsEarned}} puntos fidelidad </strong>',
    modal: {
      missingAdvantage: {
        buttons: {
          cancel: {
            label: 'Volver al carrito',
          },
          submit: {
            label: 'Ir a la caja',
          },
        },
        title: 'Tus ventajas te esperan',
      },
      shippingCountry: {
        alert: '¡Atención! Si cambias de país, se vaciará tu carrito',
        title: '¿Quieres cambiar de país de envío?',
      },
    },
    packsWithBlockingAlerts:
      'Verificare i prerequisiti di acquisto per i seguenti venditori: <strong>{{packsWithBlockingAlerts}}</strong>',
    paymentMethods: {
      title: 'Formas de pago disponibles',
    },
    productTile: {
      composedOf: 'Compuesto por',
      itemMovedToWishlistAnnouncement: 'El artículo {{productName}} se ha añadido a la lista de deseos',
      itemRemovedAnnouncement: 'El artículo {{productName}} se ha eliminado del carrito',
      removeItem: 'Eliminar artículo',
      sendToWishlist: 'Incluir en la lista de deseos',
      shippedBy: 'Vendido por: ',
    },
    proocedToCart: 'Ir al carrito',
    quantity: 'Cantidad',
    recommendedProducts: {
      title: 'Compra con',
    },
    summary: {
      additional: {
        cashOnDelivery: 'Pago en el momento de la entrega',
        title: 'Suplementos',
      },
      continueShopping: 'continúa comprando',
      coupons: {
        removeCoupon: 'Eliminar',
        title: 'Introducir un código de descuento (opcional)',
      },
      freeShipping: 'Gratis',
      freeShippingFrom: 'Envíos gratuitos a partir de {{freeShippingFromAmount}}',
      giftCard: 'Tarjetas regalo',
      proocedToCheckout: 'Continuar',
      shippingCountry: {
        edit: 'Cambiar',
        title: 'País de envío',
      },
      shippingProfiles: {
        title: 'Envío',
      },
      subtotal: 'Subtotal',
      tax: 'IVA',
      title: 'Tu pedido',
      toFreeShipping: 'Faltan <strong>{{toFreeShippingAmount}}</strong> para el envío gratuito',
      toFreeShippingComplete: 'Has conseguido el <b>envío gratuito</b>',
      totalBillingCost: 'Total (IVA incluido)',
      totalCost: 'Total por pagar',
      totalDiscount: 'Descuentos',
      totalProductsCost: 'Coste de productos',
      totalProductsCostTaxable: 'Coste de productos (IVA excluido)',
    },
    title: 'Mi carrito',
  },
  checkout: {
    backToCart: 'Volver al carrito',
    billing: {
      addNewAddress: 'Añadir nueva dirección',
    },
    cancel: 'Anular',
    cannotStartPayment: 'Vaya, algo ha fallado en tu carrito. Comprueba los artículos para proceder',
    edit: 'Modificar',
    invoice: {
      notRequested: 'No has pedido factura',
      requested: 'Has pedido factura',
    },
    shipping: {
      addNewAddress: 'Añadir nueva dirección',
    },
    step: {
      billingAddress: {
        subTitle: 'Coincide con la de entrega',
        title: 'Dirección de pago',
      },
      email: {
        alert: {
          buttons: {
            label: '',
          },
          title: '',
        },
        insertCredentials: 'Introduce tus credenciales y completa el acceso',
        login: 'Entrar',
        orderAs: 'Estás haciendo el pedido como',
        subTitle1: ' Completa tu pedido más rápidamente.',
        subTitle2: 'Accede con tu cuenta',
        title: 'Correo electrónico',
      },
      paymentMethod: {
        subTitle: 'Elige la forma de pago',
        title: 'Forma de pago',
      },
      shippingAddress: {
        title: 'Dirección de entrega',
      },
    },
    summary: {
      additional: {
        cashOnDelivery: 'Pago en el momento de la entrega',
        title: 'Suplementos',
      },
      cartItem: {
        edit: 'Modificar',
        title: 'Estás comprando',
      },
      coupon: {
        add: 'Añadir',
        edit: 'Modificar',
        title: 'Cupones',
      },
      giftCard: {
        add: 'Añadir',
        edit: 'Modificar',
        title: 'Tarjeta regalo',
      },
      shipping: {
        title: 'Envío',
      },
      shippingCountry: {
        title: 'País de envío',
      },
      subtotal: 'Subtotal',
      title: 'Tu pedido',
      totalBillingCost: 'Total (IVA incluido)',
      totalCost: 'Total por pagar',
      totalProductsCost: 'Total de productos',
    },
    thankYou: {
      cashOnDelivery: {
        amountToPayOnDelivery: 'Importe por pagar en el momento de la entrega',
      },
    },
  },
  contactUs: {
    customerOrder: {
      label: '¿Para qué pedido necesitas ayuda?',
      placeholder: 'Selecciona tu pedido',
    },
    notSatisfied: {
      label: '¿No has encontrado la respuesta que buscabas? ¡Contáctanos!',
    },
    satisfied: {
      label: '¿Has encontrado la respuesta que buscabas?',
      no: 'no',
      yes: 'sí',
    },
    subject: {
      label: '¿Qué información necesitas?',
      placeholder: 'Selecciona una opción',
    },
  },
  customerCare: {
    contact: 'Contáctanos',
    help: '¿Te podemos ayudar?',
    rightOfWithdrawal: {
      noOrders: 'No tienes ningún pedido sobre el que puedas ejercer el derecho de desistimiento',
    },
    select: {
      label: '¿Qué información necesitas?',
      optionLabel: 'Selecciona una opción',
    },
    service: 'Consulta el área Atención al cliente para una ayuda fácil y rápida',
  },
  error: {
    pageNotFound: 'Vaya. No hemos encontrado la página que buscabas',
  },
  fixedPagesName: {
    account: 'account',
    cart: 'cart',
    'change-password': 'change-password',
    checkout: 'checkout',
    error: 'error',
    'forgot-password': 'forgot-password',
    home: 'home',
    login: 'login',
    newsletter: 'newsletter',
    'order-ko': 'order-ko',
    'order-ok': 'order-ok',
    register: 'register',
    search: 'search',
    sitemap: 'sitemap',
    template: 'template',
    test: 'test',
    'unsubscribe-newsletter': 'unsubscribe-newsletter',
    whois: 'whois',
  },
  footer: {
    paymentsMethod: 'Formas de pago',
  },
  form: {
    addToCartForm: {
      buttons: {
        availabilityEmailNotification: {
          addLong: { label: 'Avísame cuando esté disponible' },
          addShort: { label: 'Avísame' },
          remove: { label: 'Eliminar el aviso' },
        },
        cancel: { label: 'Anular' },
        reset: { label: 'Reset' },
        submit: { label: 'Añadir al carrito' },
        submitButNotAvailable: { label: 'No disponible' },
      },
      fields: {
        giftCard: {
          message: {
            label: 'Mensaje',
            placeholder: '',
          },
          receiverEmail: {
            label: 'Correo electrónico del destinatario',
            placeholder: '',
          },
          receiverName: {
            label: 'Nombre del destinatario',
            placeholder: '',
          },
          senderName: {
            label: 'Tu nombre',
            placeholder: '',
          },
          value: {
            placeholder: 'Selecciona una opción',
          },
        },
        quantity: {
          label: 'Cantidad',
          placeholder: 'Selecciona una de las opciones',
        },
        skuAttributes: {
          Gift_card_valore: {
            placeholder: 'Selecciona el valor',
          },
        },
        skus: {
          label: 'SKU',
          placeholder: 'Selecciona un SKU',
        },
      },
      fieldsets: {
        productVariants: {
          legend: 'Formatos disponibles',
        },
        skus: {
          legend: 'Seleccione el producto deseado',
        },
      },
      misc: {
        productVariants: 'Formato',
      },
      modal: {
        title: '',
      },
      outcome: {
        failure: {
          AddingSkuNotCompatible: {
            body: 'Este producto no se puede enviar junto con otros productos de su cesta. Quieres proceder vaciando el carrito actual?', // da revisionare
            buttons: {
              no: { label: 'No' },
              yes: { label: 'Sí' },
            },
            title: 'Lo sentimos',
          },
        },
        success: {
          body: 'Producto añadido al carrito',
          buttons: {
            continueShopping: { label: 'Continúa comprando' },
            goToCart: { label: 'Ir al carrito' },
          },
          title: 'Producto añadido al carrito',
        },
      },
    },
    addressForm: {
      account: {
        defaultBilling: {
          label: 'Configurar como dirección de pago predefinida',
        },
        defaultShipping: {
          label: 'Configurar como dirección de envío predefinida',
        },
      },
      address: {
        addressLine1: {
          label: 'Dirección',
          placeholder: '',
        },
        addressLine2: {
          label: 'Número, piso, etc.',
          placeholder: '',
        },
        addressLine3: {
          label: '',
          placeholder: '',
        },
        alternativePhone: {
          label: 'Teléfono alternativo',
          placeholder: '',
        },
        city: {
          label: 'Ciudad',
          placeholder: '',
        },
        civicNumber: {
          label: 'Número',
          placeholder: '',
        },
        country: {
          label: 'País',
          placeholder: '',
        },
        latitude: {
          label: 'Latitud',
          placeholder: '',
        },
        longitude: {
          label: 'Longitud',
          placeholder: '',
        },
        middleName: {
          label: 'Segundo nombre',
          placeholder: '',
        },
        name: {
          label: 'Nombre',
          placeholder: '',
        },
        phone: {
          label: 'Teléfono',
          placeholder: '',
        },
        province: {
          label: 'Provincia',
          placeholder: 'Provincia',
        },
        region: {
          label: 'Región',
          placeholder: '',
        },
        shippingToAlert: 'Estás enviando a {{locale}}, vuelve atrás para cambiar el país de envío.',
        surname: {
          label: 'Apellidos',
          placeholder: '',
        },
        zipCode: {
          label: 'Código postal',
          placeholder: '',
        },
      },
      buttons: {
        cancel: {
          label: 'Anular',
        },
        edit: {
          label: 'Modificar',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Añadir',
        },
      },
      copyFromBilling: {
        label: 'Usar la misma dirección de pago',
      },
      copyFromShipping: {
        label: 'Usar la misma dirección de envío',
      },
      copyToBilling: {
        label: 'Configurar también como dirección de pago',
      },
      copyToShipping: {
        label: 'Configurar también como dirección de envío',
      },
      editAddressTitle: 'Modificar dirección',
      invoice: {
        data: {
          company: {
            label: 'Razón social',
            placeholder: '',
          },
          pec: {
            label: 'Correo electrónico certificado',
            placeholder: '',
          },
          taxCode: {
            label: 'Código fiscal',
            placeholder: '',
          },
          uniqueCode: {
            label: 'Código SDI',
            placeholder: '',
          },
          vatNumber: {
            label: 'Número de IVA',
            placeholder: '',
          },
        },
        request: {
          label: '¿Quieres factura?',
        },
        type: {
          label: 'Tipo de cliente',
          options: {
            company: 'Empresa',
            freelance: 'Empresa individual/profesional',
            privatePerson: 'Privado',
          },
        },
      },
      modal: {
        title: '',
      },
      newAddressTitle: 'Introduce una nueva dirección',
    },
    cartAddressFromAddressBookForm: {
      buttons: {
        cancel: { label: 'Anular' },
        editAddress: { label: 'Modificar dirección' },
        newAddress: { label: 'Añadir nueva dirección' },
        reset: { label: 'Reset' },
        submit: { label: 'Confirmar' },
      },
    },
    cartEmailForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          checkout: {
            label: 'Modificar correo electrónico',
          },
          whoIs: {
            label: 'Seguir con el pedido',
          },
        },
      },
      fields: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Correo electrónico',
        },
        newsletterConsent: {
          label: '',
          radios: {
            false: '',
            true: '',
          },
        },
        privacy: {
          label: 'Doy mi consentimiento al tratamiento de los datos personales.',
        },
      },
      handlers: {
        registeredEmail: {
          body: '',
          buttons: {
            cancel: {
              label: '',
            },
            submit: {
              label: '',
            },
          },
          title: '',
        },
      },
      modal: {
        title: '',
      },
    },
    cartGenericCouponForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Aplicar',
        },
      },
      fields: {
        code: {
          label: '',
          placeholder: 'Introducir código',
        },
      },
      modal: {
        title: '',
      },
    },
    cartPaymentMethodsForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Confirmar',
        },
      },
      modal: {
        title: '',
      },
    },
    cartPersonalCouponsForm: {
      misc: {
        noCoupon: '',
      },
      modal: {
        title: '',
      },
    },
    changePasswordByTokenForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Enviar solicitud',
        },
      },
      fields: {
        confirmNewPassword: {
          label: 'Confirmar nueva contraseña',
          placeholder: 'Confirmar nueva contraseña',
        },
        newPassword: {
          label: 'Nueva contraseña',
          placeholder: 'Nueva contraseña',
        },
      },
      modal: {
        title: '',
      },
      outcome: {
        success: {
          body: 'El procedimiento de cambio de contraseña ha finalizado satisfactoriamente',
          title: 'Confirmar cambio de contraseña',
        },
      },
    },
    changePasswordForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Enviar solicitud',
        },
      },
      fields: {
        confirmNewPassword: {
          label: 'Confirmar nueva contraseña',
          placeholder: 'Confirmar nueva contraseña',
        },
        currentPassword: {
          label: 'Contraseña actual',
          placeholder: 'Contraseña actual',
        },
        newPassword: {
          label: 'Nueva contraseña',
          placeholder: 'Nueva contraseña',
        },
      },
      modal: {
        title: 'Cambio de contraseña',
      },
      outcome: {
        success: {
          body: 'El procedimiento de cambio de contraseña ha finalizado satisfactoriamente',
          title: 'Confirmar cambio de contraseña',
        },
      },
    },
    consentsForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Guardar',
        },
      },
      fields: {
        loyaltyProgram: {
          label: 'Aceptación loyalty',
          radios: {
            false: 'No',
            true: 'Sí',
          },
        },
        marketing: {
          label: 'Aceptación marketing',
          radios: {
            false: 'No',
            true: 'Sí',
          },
        },
        newsletter: {
          label: 'Aceptación newsletter',
          radios: {
            false: 'No',
            true: 'Sí',
          },
        },
        profiling: {
          label: 'Aceptación creación de perfil',
          radios: {
            false: 'No',
            true: 'Sí',
          },
        },
      },
      modal: {
        title: '',
      },
    },
    customerCareForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Enviar',
        },
      },
      fields: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Correo electrónico',
        },
        message: {
          label: 'Mensaje',
          placeholder: 'Mensaje',
        },
        name: {
          label: 'Nombre',
          placeholder: 'Nombre',
        },
        phoneNumber: {
          label: 'Teléfono',
          placeholder: 'Teléfono',
        },
        privacy: {
          label: 'Declaro haber leído y aceptado la hoja informativa de privacidad',
          placeholder: '',
        },
        surname: {
          label: 'Apellidos',
          placeholder: 'Apellidos',
        },
      },
      modal: {
        title: '',
      },
      outcome: {
        success: {
          body: 'Mensaje enviado correctamente',
          title: 'Enviar mensaje',
        },
      },
    },
    customerForm: {
      birthdate: {
        errors: {
          minAge: 'Introduce una fecha de nacimiento válida',
          minAgeWithDate: '',
          minAgeWithDate_one: 'Debes haber cumplido al menos {{count}} año',
          minAgeWithDate_other: 'Debes haber cumplido al menos {{count}} años',
        },
        label: 'Fecha de nacimiento',
      },
      businessType: {
        label: 'Cómo está registrada tu actividad',
        options: {
          company: 'Empresa',
          proprietorship: 'Empresa individual/profesional',
        },
        placeholder: 'Selecciona una opción',
      },
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          registrationLabel: 'Registrados',
          updateLabel: 'Actualizar',
          updateRequiredFieldsLabel: 'Completa el perfil',
        },
      },
      children: {
        birthdate: {
          errors: {
            minAge: 'Introduce una fecha de nacimiento válida',
            minAgeWithDate: '',
            minAgeWithDate_one: 'Debes haber cumplido al menos {{count}} año',
            minAgeWithDate_other: 'Debes haber cumplido al menos {{count}} años',
          },
          label: 'Fecha de nacimiento',
          placeholder: 'Fecha de nacimiento',
        },
        buttons: {
          add: {
            label: 'Añadir niño',
          },
          remove: {
            label: 'Eliminar niño',
          },
        },
        formGroup: {
          label: 'Niños (mín: {{min}} máx: {{max}} actuales: {{current}})',
        },
        limitDisclaimer: 'Ha alcanzado el límite máximo',
        name: {
          label: 'Nombre',
          placeholder: 'Nombre',
        },
        sex: {
          label: 'Sexo',
          options: {
            female: 'Mujer',
            male: 'Hombre',
            other: 'Prefiero no especificarlo',
          },
          placeholder: 'Selecciona una opción',
        },
        surname: {
          label: 'Apellidos',
          placeholder: 'Apellidos',
        },
      },
      company: {
        label: 'Razón social',
        placeholder: 'Razón social',
      },
      document: {
        authorityDescription: {
          label: 'Descripción de la autoridad',
          placeholder: 'Descripción de la autoridad',
        },
        authorityType: {
          label: 'Tipo de autoridad',
          options: {
            consulate: 'Consulado',
            financeOffice: 'Oficina de Finanzas',
            foreignState: 'Estado extranjero',
            motorization: 'Jefatura de Tráfico',
            municipality: 'Ayuntamiento',
            other: 'Otro',
            prefecture: 'Prefectura',
            unknown: 'Desconocido',
          },
          placeholder: 'Tipo de autoridad',
        },
        districtName: {
          label: 'Nombre distrito',
          placeholder: 'Nombre distrito',
        },
        districtType: {
          label: 'Tipo distrito',
          placeholder: 'Tipo distrito',
        },
        documentNumber: {
          label: 'Número de documento',
          placeholder: 'Número de documento',
        },
        documentType: {
          label: 'Tipo de documento',
          options: {
            drivingLicense: 'Permiso de conducir',
            identityCard: 'Documento de identidad',
            passport: 'Pasaporte',
          },
          placeholder: 'Tipo de documento',
        },
        label: 'Documento',
        releaseDate: {
          label: 'Fecha de emisión',
          placeholder: 'Fecha de emisión',
        },
      },
      email: {
        label: 'Correo electrónico',
        placeholder: 'Correo electrónico',
      },
      enableBusinessData: {
        formGroup: {
          label: '¿Deseas añadir los datos de tu actividad?',
        },
        options: {
          no: 'No',
          yes: 'Sí',
        },
      },
      enableChildren: {
        formGroup: {
          label: '¿Deseas añadir niños?',
        },
        options: {
          no: 'No',
          yes: 'Sí',
        },
      },
      enableDocument: {
        formGroup: {
          label: '¿Deseas añadir un documento?',
        },
        options: {
          no: 'No',
          yes: 'Sí',
        },
      },
      marketingConsent: {
        label: 'Marketing',
      },
      modal: {
        title: 'Datos personales',
      },
      name: {
        label: 'Nombre',
        placeholder: 'Nombre',
      },
      newsletterConsent: {
        label: 'Newsletter',
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Contraseña',
      },
      pec: {
        label: 'Dirección correo electrónico certificado',
        placeholder: 'Dirección correo electrónico certificado',
      },
      phoneNumbers: {
        buttons: {
          add: {
            label: 'Añadir teléfono',
          },
          remove: {
            label: 'Eliminar teléfono',
          },
        },
        label: 'Teléfono',
        placeholder: 'Teléfono',
      },
      privacyConsent: {
        label: 'Privacidad',
      },
      profile: {
        label: 'Perfil',
        options: {
          business: 'Trabajo',
          private: 'Privado',
        },
        placeholder: 'Selecciona una opción',
      },
      profilingConsent: {
        label: 'Creación de perfil',
      },
      sex: {
        label: 'Sexo',
        options: {
          female: 'Mujer',
          male: 'Hombre',
          other: 'Prefiero no especificarlo',
        },
        placeholder: 'Selecciona una opción',
      },
      surname: {
        label: 'Apellidos',
        placeholder: 'Apellidos',
      },
      taxCode: {
        label: 'Código fiscal',
        placeholder: 'Código fiscal',
      },
      uniqueCode: {
        label: 'Código SDI',
        placeholder: 'Código SDI',
      },
      vatNumber: {
        label: 'Número de IVA',
        placeholder: 'Número de IVA',
      },
    },
    emailToCartForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Seguir con el pedido',
        },
      },
      modal: {
        title: '',
      },
    },
    exampleForm: {
      modal: {
        title: '',
      },
    },
    forgotPasswordForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Enviar solicitud',
        },
      },
      fields: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Correo electrónico',
        },
      },
      modal: {
        title: '',
      },
      outcome: {
        success: {
          body: 'Operación finalizada satisfactoriamente.\n\nTe hemos enviado un correo electrónico con las instrucciones que debes seguir.',
          title: 'Solicitud de restablecimiento de contraseña',
        },
      },
    },
    giftCardForm: {
      buttons: {
        balanceCheck: {
          label: 'Comprobar saldo',
        },
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Utilizar',
        },
      },
      fields: {
        code: {
          label: 'Tarjeta regalo',
          placeholder: 'Introduce el número de la tarjeta regalo',
        },
      },
    },
    localeForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Ir',
        },
      },
      fields: {
        locale: {
          label: 'Idioma',
        },
        shippingCountry: {
          label: 'País',
        },
      },
      modal: {
        title: '',
      },
    },
    loginForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Inicio de sesión',
        },
      },
      fields: {
        password: {
          label: 'Contraseña',
          placeholder: 'Contraseña',
        },
        username: {
          label: 'Correo electrónico',
          placeholder: 'Correo electrónico',
        },
      },
      modal: {
        title: '',
      },
    },
    loyaltyProgramForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Guardar perfil',
        },
      },
    },
    newsletterForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Inscribirse',
        },
        submitThin: {
          label: 'Inscribirse',
        },
      },
      fields: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Introduce tu dirección de correo electrónico',
        },
        name: {
          label: 'Nombre',
          placeholder: 'Introduce tu nombre',
        },
        surname: {
          label: 'Apellidos',
          placeholder: 'Introduce tus apellidos',
        },
      },
      fieldsets: {
        consents: {
          fields: {
            newsletterConsent: {
              label: '',
            },
          },
          legend: 'Consentimientos de privacidad',
        },
      },
      modal: {
        title: '',
      },
      outcome: {
        success: {
          body: '¡Enhorabuena! Desde ahora formas parte de la newsletter.',
          buttons: {
            ok: {
              label: 'Ok',
            },
          },
          title: 'Inscripción a la newsletter realizada satisfactoriamente',
        },
      },
    },
    orderGuestForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Buscar',
        },
      },
      fields: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'correo electrónico',
        },
        orderCode: {
          label: 'Código de pedido',
          placeholder: 'código de pedido',
        },
      },
      modal: {
        title: '',
      },
    },
    recommendedCartProduct: {
      buttons: {
        reset: {
          label: 'Cancelar',
        },
        submit: {
          label: 'Confirmar',
        },
      },
    },
    restartPaymentForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Pagar ahora',
        },
      },
      fields: {
        checkbox: {
          label: '',
        },
      },
      modal: {
        title: '',
      },
    },
    reviewForm: {
      buttons: {
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Dejar una reseña',
        },
      },
      fields: {
        message: {
          label: 'Añade un comentario',
          placeholder: 'Escribe tu reseña',
        },
        rating: {
          label: '¿Cuánto te ha gustado <strong>{{productName}}</strong>?',
        },
      },
      modal: {
        title: '¡Dinos lo que piensas!',
      },
      outcome: {
        failure: {
          generic: {
            body: 'No hemos encontrado entre tus compras ningún pedido que contenga este producto',
            title: 'Lo sentimos',
          },
        },
        success: {
          body: 'Tu reseña será publicada después de haber sido revisada por nuestro servicio de atención al cliente.',
          title: '¡Gracias por tus comentarios!',
        },
      },
    },
    shopSearchForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Buscar',
        },
      },
    },
    simpleSearchForm: {
      fields: {
        text: {
          label: 'Buscar',
          placeholder: 'Buscar',
        },
      },
    },
    startPaymentForm: {
      buttons: {
        cancel: {
          label: 'Anular',
        },
        reset: {
          label: 'Reset',
        },
        submit: {
          label: 'Comprar',
        },
      },
      fields: {
        checkbox: {
          label: '',
        },
      },
      modal: {
        title: '',
      },
    },
    taxBenefitsForm: {
      buttons: {
        browseFile: 'Adjuntar documento',
        cancel: 'Anular',
        reset: {
          label: 'Reset',
        },
        submit: 'Guardar documentación',
      },
      documentValidation: {
        approved: 'Documento convalidado.',
        awating: 'Documentos en fase de aprobación.',
        rejected: 'Documento rechazado. Cargar un nuevo documento válido.',
      },
      documentation: {
        label: 'Descargar la documentación',
      },
      taxCode: {
        label: 'Código fiscal',
        placeholder: 'Código fiscal',
      },
    },
    updateCustomerRequiredFieldsForm: {
      modal: {
        title: '',
      },
    },
  },
  header: {
    cartSummary: '',
    cartSummary_one: 'Resumen del pedido ({{count}} artículo)',
    cartSummary_other: 'Resumen del pedido ({{count}} artículos)',
    freeShippingFrom: 'Envíos gratuitos a {{locale}} desde {{from}}',
    sendTo: 'País: {{country}} | {{locale}}',
  },
  i18nTest: 'Esto es una prueba de b2x-react',
  innerSearchFilter: {
    noResults: 'Ningún resultado',
    search: 'Buscar...',
  },
  misc: {
    account: 'Cuenta',
    addAddress: 'Añadir dirección',
    addToCart: 'Añadir',
    amount: 'Importe',
    availabilityEmailNotification: 'Avísame',
    availabilityNotification: 'Te avisaremos cuando esté disponible',
    back: 'Atrás',
    backToHome: 'Volver a inicio',
    bestPrice: {
      info: 'info',
      modal: {
        lowestPrice: 'Precio más bajo de los últimos 30 días',
        priceToday: 'Cuánto cuesta este artículo hoy',
        title: 'Historial del precio del artículo',
      },
      priceLabel: 'Último precio más bajo:',
    },
    buy: 'Comprar',
    categories: 'Categorías',
    changeCountryMessage: '¡Atención! Si cambias de país, se vaciará tu carrito',
    checkout: 'Checkout',
    code: 'Código',
    couponDetails: 'Usa el código: <strong>{{code}}</strong>',
    customerForm: {
      registrationSuccessful: {
        modal: {
          body: 'Gracias por suscribirse', //da revisionare
          title: 'Inscripción completada', //da revisionare
        },
      },
    },
    customerService: 'Asistencia a clientes',
    delete: 'Eliminar',
    deleteAddress: {
      body: '¿Estás seguro de que deseas eliminar esta dirección?',
      title: 'Eliminar dirección',
    },
    directions: 'Indicaciones',
    discoverMore: 'descubre más',
    discoverOurCollection: 'Descubre la selección',
    discoverOurProducts: 'Descubre nuestros productos',
    discoverSimilarProducts: 'Descubre productos similares',
    doubleOptIn: {
      body: 'Tu dirección de correo electrónico ha sido validada satisfactoriamente. Inicia sesión para empezar a navegar.',
      title: 'Cuenta verificada',
    },
    edit: '',
    fileInput: {
      label: 'Elegir archivo',
      placeholder: 'Ningún archivo seleccionado',
      uploading: 'uploading...',
    },
    filter: 'Filtrar',
    filterAndOrderBy: 'Filtrar y ordenar por',
    filterBy: 'Filtrar por',
    filterYourSearchResults: 'Filtra los resultados de tu búsqueda',
    followUs: 'Síguenos',
    fromPrice: 'desde {{value}}',
    giftCard: {
      balance: {
        activation: 'Activación',
        expiration: 'Vencimiento',
        title: 'Tarjeta regalo detalle',
        value: 'Saldo',
      },
      label: 'Tarjeta regalo',
      message: 'Visualizar el mensaje',
      receiver: {
        label: 'Para:',
        mail: 'Correo electrónico:',
      },
      sender: {
        label: 'De:',
        mail: 'Correo electrónico:',
      },
      value: 'Valor:',
    },
    giftProduct: 'Obsequio',
    gratis: 'Gratis',
    invalid_form_values: 'Comprueba todos los campos antes de continuar',
    invoice: {
      company: 'Razón social',
      pec: 'Correo electrónico certificado',
      taxCode: 'Código fiscal',
      uniqueCode: 'Código SDI',
      vatNumber: 'Número de IVA',
    },
    locale: {
      box: {
        title: {
          country: 'Selecciona país e idioma',
          language: 'Selecciona idioma',
        },
      },
    },
    loginRegister: 'Entrar/Registrarse',
    myOrders: 'Mis pedidos',
    newProductSticker: 'New',
    newsletterTitle: 'Newsletter',
    or: '',
    orderBy: 'Ordena por',
    orderCode: 'Código de pedido',
    passwordInput: {
      hide: 'ocultar',
      show: 'mostrar',
    },
    payPalCheckout: {
      advanced: {
        privacyNotice: '',
      },
      capture: {
        errorModal: {
          body: '',
          title: '',
        },
      },
      form: {
        buttons: {
          cancel: '',
          submit: '',
        },
        fields: {
          cvv: {
            placeholder: '',
          },
          expiry: {
            placeholder: '',
          },
          name: {
            placeholder: '',
          },
          number: {
            placeholder: '',
          },
        },
        state: {
          invalid: '',
        },
      },
    },
    payments: 'Pagos',
    preferences: 'Podría interesarte',
    price: '{{value}}',
    pricePerShape: '{{price}} por {{shape}}',
    pricePerUnit: '{{price}} por {{measurementUnit}}',
    priceVatIncluded: 'IVA incl. {{price}}',
    productNotAvailable: 'No disponible',
    productsPicker: {
      progress: '',
      progress_one: '',
      progress_other: '',
      select: '',
      selected: '',
    },
    quickPurchaseLastOrder: {
      addAllToCart: 'Comprar de nuevo',
      myOrders: 'Ver el historial de pedidos',
    },
    readMore: 'Leer más',
    register: 'Regístrate ya',
    relatedProducts: 'También podría interesarte',
    removeFilters: 'Eliminar todos',
    searchItemResult: '',
    searchItemResult_one: '{{count}} resultado',
    searchItemResult_other: '{{count}} resultados',
    shipment: 'Envíos y devoluciones',
    showLess: 'Cerrar',
    showMore: 'Leer todo',
    sizeGuide: 'guía de tallas',
    storeName: '',
    time: {
      days: '',
      days_one: 'Día',
      days_other: 'Días',
      hours: '',
      hours_one: 'Hora',
      hours_other: 'Horas',
      minutes: '',
      minutes_one: 'Minuto',
      minutes_other: 'Minutos',
      seconds: '',
      seconds_one: 'Segundo',
      seconds_other: 'Segundos',
    },
    unknownItem: 'producto desconocido',
    unsubscribeNewsletterByToken: {
      pending: 'Te estamos dando de baja de la newsletter...',
      success: 'Baja de la newsletter realizada satisfactoriamente',
      title: 'Newsletter',
    },
    vat: '(IVA al {{value}} %)',
    viewAll: 'Ver todos',
    welcomeMessage: 'Hola, {{name}}',
    wishlist: 'Lista de deseos',
    youSearchedFor: 'Has buscado:',
  },
  modal: {
    geolocation: {
      content: '{{storeName}} quiere acceder a tu posición para aprovechar mejor el servicio.',
      title: 'Geolocalización {{storeName}}',
    },
  },
  paymentMethod: {
    ALIAS: 'Pago mediante Alias',
    ANTICIPATO_BONIFICO: 'Adelanto con transferencia bancaria',
    ANTICIPATO_CC: 'Adelanto con tarjetas de crédito',
    B2X_DIRECT: '',
    BANCOMAT_PAY: 'BANCOMAT Pay',
    BANK_TRANSFER: 'Transferencia bancaria',
    BNL: 'Tarjetas de crédito mediante BNL',
    CALL_CENTER: 'Call center',
    CASH: 'CASH',
    CASH_ON_DELIVERY: 'Contra reembolso',
    CMCIC: '',
    EASYPAY_CC: '',
    EASYPAY_MB: '',
    EASYPAY_MBWAY: '',
    ECPAY: '',
    FATTURA_30: 'Factura a 30 días',
    FATTURA_60: 'Factura a 60 días',
    FIDELITY_CARD: '',
    GESTPAY: '',
    GESTPAY_MYBANK: '',
    GIFT_CARD: 'Tarjeta regalo',
    KEYCLIENT: 'Tarjeta de crédito',
    KLARNA: '',
    MULTIBANCO: '',
    MYBANK: '',
    NOT_NECESSARY_PAYMENT: 'Pago no necesario',
    NOT_SETTED_PAYMENT: 'Pago no configurado',
    PAYPAL: 'PayPal',
    PAYPAL_V2: '',
    PAY_ON_PHYSICAL_SHOP: '',
    POS: 'Tarjeta de crédito con POS in situ',
    POSTE_BPIOL: 'Poste BPIOL',
    POSTE_BPOL: 'Poste BPOL',
    POSTE_CC: 'Tarjeta de crédito mediante Poste',
    POSTE_PAY: 'PostePay',
    RIBA60: 'RiBa 60',
    RIBA_30: 'RiBa 30',
    RIMESSA_DIRETTA: 'Envío directo',
    SATISPAY: 'Satispay',
    SCALAPAY: 'Pago mediante Scalapay',
    SETEFI: 'Tarjeta de crédito',
    SETEFI_MASTERPASS: 'Masterpass',
    THIRD_PARTIES: 'PostePay',
    WANNME_BT: '',
    WANNME_CC: '',
    WANNME_PAY7: '',
    WANNME_RECURRENT: '',
    WORLDLINE_EASY_CHECKOUT: 'Tarjeta de débito/crédito',
  },
  product: {
    availability: {
      inStock: 'En stock: {{availability}}',
      inThreshold: 'En el umbral: {{availability}}',
      outOfStock: 'Agotado',
    },
    caloriesPer100g: 'Calorías por 100 g',
    code: 'Código de producto',
    cookingMinutes: 'Minutos - tiempo de cocción',
    description: 'Descripción',
    details: 'Detalles del producto',
    dryingTime: 'Horas de secado certificadas',
    features: 'Características',
    freeShippingFrom: 'Envíos gratuitos a partir de {{freeShippingFromAmount}}',
    fromPrice: 'a partir de',
    minutesOfCookingAlDente: 'Minutos - al dente',
    promo: 'Promoción',
    relatedProduct: {
      title: 'También te podría gustar',
    },
    selectSize: 'Selecciona una talla',
    share: 'Compartir',
    size: 'Formato',
    sizeGuide: 'Guía de tallas',
    temporary: {
      shipping: 'Entrega rápida y devolución fácil en menos de 30 días.',
      sizeGuide: '¿No sabes qué talla tienes?',
    },
    usageAndMaintenance: 'Uso y mantenimiento',
  },
  reviews: {
    buttons: {
      reviewForFirst: 'Sé el primero en escribir una reseña sobre este producto',
      showMore: 'Mostrar otras',
      signIn: 'Entrar',
      signUp: 'Registrados',
      writeReview: 'Dejar una reseña',
    },
    messages: {
      customer: 'Comparte tu experiencia sobre este producto.',
      guest: 'Accede o regístrate para dejar una reseña.',
      withReviwes: '¿Ya has probado este producto?',
      withoutReviews:
        '¿Ya has probado este producto? Sé el primer el compartir tu opinión y en decirnos lo que piensas.',
    },
    misc: {
      emptyList: 'No hay reseñas',
      filterBy: 'Filtrar por',
      review: '',
      review_one: '{{count}} reseña',
      review_other: '{{count}} reseñas',
      star: '',
      star_one: 'Estrella',
      star_other: 'Estrellas',
      writeReview: 'Dejar una reseña',
    },
    review: {
      notVerified: 'Reseña no verificada',
      purchasedOn: 'Comprado: {{date}}',
      reviewedOn: 'Escrita el: {{date}}',
    },
    titles: {
      withReviwes: 'Todas las reseñas',
      withoutReviews: 'Dejar una reseña',
    },
  },
  sharingModal: {
    methods: {
      clipboard: {
        label: 'Copiar enlace',
        success: 'Enlace copiado en el portapapeles',
      },
      email: {
        label: 'Correo electrónico',
      },
      facebook: {
        label: 'Facebook',
      },
      messenger: {
        label: 'Messenger',
      },
      whatsApp: {
        label: 'WhatsApp',
      },
      x: {
        label: 'X',
      },
    },
    title: 'Compartir',
  },
  sortingOption: {
    default: 'Relevancia',
    id: {
      asc: '',
      desc: '',
    },
    name: {
      asc: '',
      desc: '',
    },
    price: {
      asc: 'Precio bajo',
      desc: 'Precio alto',
    },
    priority: {
      asc: '',
      desc: '',
    },
  },
  storeLocator: {
    filterPanel: {
      selectProduct: 'Seleccionar el producto',
    },
    listingPanel: {
      loading: 'loading...',
      shopsCount: '',
      shopsCount_one: '{{count}} punto de venta',
      shopsCount_other: '{{count}} puntos de venta',
    },
    modal: {
      desktopPhone: {
        content: 'Para más información sobre {{name}}, póngase en contacto con {{phoneNumber}}',
        title: 'Ponte en contacto con el punto de venta',
      },
      gallery: {
        title: 'Foto punto de venta',
      },
      geolocationError: {
        content: 'Geolocalización negada',
        title: 'Imposible centrar el mapa, geolocalización negada',
      },
    },
    shopDetails: {
      closed: 'Cerrado',
      cta: {
        call: 'Llamar',
        directions: 'Indicaciones de situación',
      },
      description: 'Descripción',
      openingDays: {
        FRIDAY: 'Viernes',
        MONDAY: 'Lunes',
        SATURDAY: 'Sábado',
        SUNDAY: 'Domingo',
        THURSDAY: 'Jueves',
        TUESDAY: 'Martes',
        WEDNESDAY: 'Miércoles',
      },
      socialNetwork: 'Red social',
    },
    shopTile: {
      CLOSED: 'Cerrado',
      OPEN: 'Abierto',
      closesAtDayTime: 'Cierra el {{day}} a las {{time}}',
      closesAtTime: 'Cierra a las {{time}}',
      copyLink: 'Copiar enlace',
      linkCopied: 'Enlace copiado en el portapapeles',
      opensAtDayTime: 'Abre el {{day}} a las {{time}}',
      opensAtTime: 'Abre a las {{time}}',
      share: 'Compartir',
    },
  },
  survey: {
    buttons: {
      complete: {
        label: 'Descubra el resultado',
      },
      nextQuestion: {
        label: 'Siguiente',
      },
      prevQuestion: {
        label: 'Volver',
      },
      reset: {
        label: 'Reiniciar',
      },
    },
    error: {
      selectAnswer: {
        description: 'Seleccione una respuesta para continuar con la encuesta',
        title: 'Atención',
      },
    },
  },
  testPopupPage: {
    homePage: {
      description:
        'El modo de vista previa deshabilita el retraso y otras funciones del popup para facilitar la prueba visual del diseño.',
      idPopup: 'ID del Popup',
      previewMode: 'Modo de vista previa',
      submit: 'Mostrar popup',
      title: 'Introduce el id del popup que deseas probar',
    },
    idPage: {
      button: 'Probar el popup',
      description: 'Haz clic en el botón de abajo para mostrar el popup.',
      details: 'Configuración del popup',
      error: 'Error al recuperar el popup',
      info: 'No es necesario recargar la página después de modificar la configuración.',
      previewMode: 'El modo de vista previa está activo',
      title: 'En esta página puedes probar el funcionamiento del popup {{id}}',
    },
  },
  topSuggestionsBox: {
    categories: 'Categorías',
    popularSearches: 'Búsquedas populares',
    recentSearches: 'Búsquedas recientes',
    showAllProducts: 'Descubre todos nuestros productos',
  },
  updateCustomerRequiredFieldsPage: {
    subtitle: 'Completa tus datos y empieza a comprar en la tienda',
    title: 'Hola',
    titleWithName: 'Hola, {{name}}:',
  },
  wishlist: {
    feedback: {
      productAdded: '{{productName}} añadido a la lista de deseos',
      productRemoved: '{{productName}} eliminado de la lista de deseos',
    },
    modal: {
      availabilityNotificationDisabled: 'No te volveremos a avisar de la disponibilidad del producto.',
      availabilityNotificationEnabled: 'Te avisaremos en cuanto el producto vuelva a estar disponible.',
      buttons: {
        continueShopping: {
          label: 'Continúa comprando',
        },
        goToWishlist: {
          label: 'Ir a la lista de deseos',
        },
      },
      productAdded: 'El producto seleccionado ha sido añadido a la lista de deseos.',
      productRemoved: 'El producto seleccionado ha sido eliminado de la lista de deseos.',
      title: 'Actualización de la lista de deseos',
    },
  },
  yup: {
    array: {
      length: 'Debe contener {{length}} artículos',
      max: 'Debe contener un número menor o igual a {{max}} artículos',
      min: 'Debe contener al menos {{min}} artículos',
    },
    boolean: {
      isValue: 'Debe ser {{value}}',
    },
    custom: {
      passwordConfirmationNotMatch: 'La contraseña confirmada no es correcta',
      privacyRequired: 'Aceptar para continuar',
    },
    date: {
      max: 'Debe ser anterior a {{máx}}',
      min: 'Debe ser posterior a {{min}}',
    },
    mixed: {
      addreesIncomplete: '(Dirección incompleta; compruébala antes de continuar)',
      default: 'Campo no válido',
      defined: 'Campo no definido',
      notOneOf: 'No debe ser uno de los siguientes valores: {{values}}',
      notType: 'Debe ser de tipo `{{type}}`, pero el valor final era: {{value}}',
      oneOf: 'Debe ser uno de los siguientes valores: {{values}}',
      phoneFormatRequired: 'El número de teléfono solo debe contener números, espacios, +, -, (, ) y .',
      required: 'Campo obligatorio',
    },
    number: {
      integer: 'Debe ser un entero',
      lessThan: 'Debe ser menor que {{less}}',
      max: 'Debe ser menor o igual a {{max}}',
      min: 'Debe ser mayor o igual a {{min}}',
      moreThan: 'Debe ser mayor que {{more}}',
      negative: 'Debe ser un número negativo',
      positive: 'Debe ser un número positivo',
    },
    object: {
      noUnknown: 'El campo tiene claves no especificadas: {{unknown}}',
    },
    string: {
      email: 'Formato de correo electrónico no válido',
      length: 'Debe tener exactamente {{length}} caracteres',
      lowercase: 'Debe ser una secuencia en minúsculas',
      matches: 'Debe coincidir con: "{{regex}}"',
      max: 'Debe tener como máximo {{max}} caracteres',
      min: 'Debe tener como mínimo {{min}} caracteres',
      trim: 'No debe contener espacios',
      uppercase: 'Debe ser una secuencia en mayúsculas',
      url: 'Debe ser una URL válida',
      uuid: 'Debe ser un UUID válido',
    },
  },
};
